import { BrandType } from 'models/brand.model';
import { DealMetaDataType, DealType, EditDealType } from 'models/deals.model';
import { MealType } from 'models/meal.model';
import { UserType } from 'models/user.model';
import { ChangeEvent, createContext, useContext } from 'react';

export type DealContextType = {
  initialEditData: EditDealType;
  editDealForm: EditDealType;
  setEditDealForm: (k: EditDealType) => void;
  disabled: boolean;
  setDisabled: (k: boolean) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  dealValueTypes: DealMetaDataType[];
  dealTypes: DealMetaDataType[];
  dealRequirementTypes: DealMetaDataType[];
  dealEligibilityTypes: DealMetaDataType[];
  brands: BrandType[];
  users: UserType[];
  setUserSearchValue: (val: string) => void;
  dealToEdit: DealType | null;
  setDealToEdit: (value: DealType) => void;
  dealLoading: boolean;
  meals: MealType[];
};

export const EditDealContext = createContext({} as DealContextType);

const useEditDealContext = () => {
  const context = useContext(EditDealContext);
  return context;
};

export default useEditDealContext;
